import React, { useEffect } from 'react';
import { FiCheckCircle, FiAlertCircle, FiAlertTriangle, FiInfo } from 'react-icons/fi';

const Toast = ({ message, type = 'error', onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const getToastConfig = () => {
        switch (type) {
            case 'error':
                return {
                    bgColor: 'bg-red-50',
                    textColor: 'text-red-600',
                    borderColor: 'border-red-200',
                    icon: <FiAlertCircle className="w-5 h-5" />,
                    progressBarColor: 'bg-red-500'
                };
            case 'success':
                return {
                    bgColor: 'bg-green-50',
                    textColor: 'text-green-600',
                    borderColor: 'border-green-200',
                    icon: <FiCheckCircle className="w-5 h-5" />,
                    progressBarColor: 'bg-green-500'
                };
            case 'warning':
                return {
                    bgColor: 'bg-yellow-50',
                    textColor: 'text-yellow-600',
                    borderColor: 'border-yellow-200',
                    icon: <FiAlertTriangle className="w-5 h-5" />,
                    progressBarColor: 'bg-yellow-500'
                };
            case 'info':
                return {
                    bgColor: 'bg-blue-50',
                    textColor: 'text-blue-600',
                    borderColor: 'border-blue-200',
                    icon: <FiInfo className="w-5 h-5" />,
                    progressBarColor: 'bg-blue-500'
                };
            default:
                return {
                    bgColor: 'bg-gray-50',
                    textColor: 'text-gray-600',
                    borderColor: 'border-gray-200',
                    icon: <FiInfo className="w-5 h-5" />,
                    progressBarColor: 'bg-gray-500'
                };
        }
    };

    const config = getToastConfig();

    return (
        <div className="fixed top-4 right-4 animate-fade-in-down" style={{ zIndex: 10000 }}>
            <div
                className={`${config.bgColor} ${config.textColor} px-4 py-3 rounded-lg shadow-lg 
                border ${config.borderColor} flex items-center gap-3 min-w-[320px] max-w-md
                transform transition-all duration-300 hover:scale-102 hover:shadow-xl`}
            >
                <div className="flex-shrink-0">
                    {config.icon}
                </div>
                <p className="flex-1 text-sm font-medium">{message}</p>
                <button
                    onClick={onClose}
                    className={`${config.textColor} opacity-70 hover:opacity-100 transition-opacity
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${type}-500 rounded-full p-1`}
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className="absolute bottom-0 left-0 h-1 w-full bg-gray-100 rounded-b-lg overflow-hidden">
                    <div
                        className={`h-full ${config.progressBarColor} animate-progress`}
                        style={{ animationDuration: `${duration}ms` }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default Toast; 